import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchDigitalTwinFailure,
  fetchDigitalTwinStart,
  fetchDigitalTwinSuccess,
} from "../../store/features/digitalTwin/digitalTwinSlice";

const URL = "/digital_twins/";

const getDigitalTwins = async (field_id) => {
  try {
    const response = await fieldDataClient.get(`${URL}?field_id=${field_id}`);
    console.log("here", response);
    return response.data;
  } catch (error) {
    console.log("here error", error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchDigitalTwinSaga(action) {
  try {
    const { field_id } = action.payload;
    const digitalTwinData = yield call(getDigitalTwins, field_id);
    yield put(fetchDigitalTwinSuccess(digitalTwinData));
  } catch (error) {
    yield put(fetchDigitalTwinFailure(error.message));
  }
}

export default function* digitalTwinSaga() {
  yield takeLatest(fetchDigitalTwinStart.type, fetchDigitalTwinSaga);
}
